<template>
    <modal-component @close="close">
        <template v-slot:header>
            <h1>Change Plan</h1>
        </template>
        
        <div v-if="loaded">
            <p>You're changing your membership to the plan: <strong>{{ name }}</strong> for <strong>{{ price }}</strong>.</p>
        </div>
        <div v-else>
            <loading />
        </div>

        <template v-slot:footer v-if="loaded">
            <progressable-button
                type="submit"
                class="py-2 px-4 rounded-md bg-primary text-white font-bold"
                :loading="loading"
                state="Changing..."
                @click.native="submit"
            >
                Confirm
            </progressable-button>
            <button class="ml-2 py-2 px-4 rounded-md bg-primary-lightest" @click="close">Cancel</button>
        </template>
    </modal-component>
</template>

<script>
export default {
    props: {
        name: {
            type: String,
            required: true,
        },
        plan: {
            type: String,
            required: true,
        },
        endpoint: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            loaded : false,
            price  : 0,
            loading: false,
        }
    },
    mounted() {
        axios.post(`${this.endpoint}/intents`, {
            plan: this.plan,
        })
        .then(response => {
            this.price = response.data.data.price,
            this.loaded = true;
        })
        .catch(err => {
            console.error(err);
        });
    },
    methods: {
        async submit() {
            this.loading = true;
            axios.put(this.endpoint, {
                plan: this.plan,
            })
            .then(response => {
                this.$emit('resolve', response);
            })
            .catch(err => {
                console.error(err);
            }).then(() => {
                this.loading = false;
            });
        },
        close() {
            this.$emit('close');
        }
    }
}
</script>